import ApplyOperation from "@/model/apply/ApplyOperation"
import ApplyMode from "@/model/apply/ApplyMode"
import { providerState } from "@/state"

export const determineApplyModeFromProviderKeyAndOperation = function(providerKey, operation, skipAccept = false) {
    switch (operation) {
        case ApplyOperation.ACCEPT_OFFER:
            if (skipAccept) return null
            const preauthResponse = providerState.getPreAuthResponse(providerKey)
            if (!preauthResponse?.operation) return null
            return determineApplyModeFromProviderKeyAndOperation(providerKey, preauthResponse.operation, true)
        case ApplyOperation.APPLY:
            return ApplyMode.FULL
        case ApplyOperation.PREQUALIFY:
            return ApplyMode.PREQUALIFY
        case ApplyOperation.PRESCREEN:
            return ApplyMode.PRESCREEN
        default:
            return null
    }
}
